export enum AppLanguage {
	English = 'EN',
	Italiano = 'IT',
}

export const DEFAULT_LANGUAGE = 'DEFAULT';
